import { Component, OnInit, Input } from '@angular/core';
import { GuestRole } from 'app/shared/models/guest-role.model';
import { Role } from 'app/shared/models/role.model';

@Component({
    selector: 'app-role-history',
    templateUrl: './role-history.component.html',
    styleUrls: ['./role-history.component.scss'],
    standalone: false
})
export class RoleHistoryComponent implements OnInit {
  @Input() guestRoles: GuestRole[]
  @Input() roles: Role[]

  constructor() { }

  ngOnInit() {
    this.guestRoles.forEach(g => g.roleName = this.roles.find(r => r.roleId == g.roleId).description)
  }

}
